<template>
  <v-navigation-drawer
    :value="$vuetify.breakpoint.mdAndUp || value"
    :permanent="$vuetify.breakpoint.mdAndUp"
    app
    color="secondary"
    width="220"
    @input="$emit('input', $event)"
  >
    <!-- Logo / Branding -->
    <div class="d-flex align-center justify-center pa-4 mt-2">
      <div class="sidebar-brand primary--text">WAIS<br><span class="sidebar-brand-sub panel_primary--text">ROWING</span></div>
    </div>

    <v-divider class="mx-4 mb-2" />

    <!-- Selected Regatta -->
    <div v-if="selectedRegatta" class="px-3 py-2">
      <div class="text-caption panel_primary--text mb-1">SELECTED REGATTA</div>
      <div class="text-body-2 primary--text font-weight-medium">{{ selectedRegatta.name }}</div>
      <div class="text-caption panel_primary--text">{{ formatDates(selectedRegatta.regattaDates) }}</div>
      <div class="text-caption panel_primary--text">{{ selectedRegatta.venue.name }}</div>
    </div>
    <div v-else class="px-3 py-2">
      <div class="text-caption panel_primary--text">No regatta selected</div>
    </div>

    <v-divider class="mx-4 my-2" />

    <!-- Nav links (mobile) -->
    <v-list dense nav class="mt-1">
      <v-list-item
        v-for="item in navItems"
        :key="item.route"
        :to="item.route"
        color="primary"
        active-class="primary--text"
      >
        <v-list-item-icon>
          <v-icon small>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-body-2">{{ item.label }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Sidebar',
  props: {
    value: Boolean
  },
  data() {
    return {
      navItems: [
        { label: 'Regattas', route: '/regattas', icon: 'mdi-calendar-star' },
        { label: 'Results', route: '/results', icon: 'mdi-podium' },
        { label: 'Lane Analysis', route: '/lane-analysis', icon: 'mdi-chart-bar' },
        { label: 'Live Races', route: '/live', icon: 'mdi-broadcast' },
        { label: 'Benchmark', route: '/benchmark', icon: 'mdi-timer-outline' },
        { label: 'Athletes', route: '/athlete-results', icon: 'mdi-account-group' },
        { label: 'Splits', route: '/splits', icon: 'mdi-chart-timeline-variant' }
      ]
    }
  },
  computed: {
    ...mapState(['selectedRegatta'])
  },
  methods: {
    formatDates(dates) {
      if (!dates || !dates.length) return ''
      if (dates.length === 1) return dates[0]
      return `${dates[0]} – ${dates[dates.length - 1]}`
    }
  }
}
</script>

<style scoped>
.sidebar-brand {
  font-family: Verdana, Geneva, sans-serif;
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 1.2;
  text-align: center;
}
.sidebar-brand-sub {
  font-size: 0.75rem;
  font-weight: normal;
  letter-spacing: 0.15em;
}
</style>
